<template>
  <div>
    <button class="button is-success" v-if="authorized === true">
      Sim
    </button>

    <b-dropdown
      :triggers="['hover']"
      aria-role="list"
      position="is-bottom-left"
      v-else
    >
      <template #trigger>
        <button
          class="button"
          :class="{
            'is-danger': authorized === false || (error && error.code),
            'is-light': authorized === undefined
          }"
          slot="trigger"
        >
          {{
            authorized === false || (error && error.code)
              ? $t("common.no")
              : authorized === undefined
              ? $t("accesses.withoutInfo")
              : "-"
          }}
        </button>
      </template>

      <b-dropdown-item aria-role="listitem" v-if="!authorized && error">
        {{ translateAccessErrorStatus(error.code) }}
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-else-if="
          device.provider === 'condlink' &&
            accessType === 'staticStorePresentedQRCode' &&
            !error
        "
        v-html="$t('accesses.internetProblemMayHaveOccuried')"
      ></b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-else-if="
          device.provider === 'condlink' &&
            accessType === 'dynamicAppPresentedQRCode' &&
            !error
        "
        v-html="$t('accesses.clientMayNotHaveTriedToUseQRCode')"
      ></b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { access } from "../../../mixins/access";

export default {
  props: ["authorized", "error", "accessType", "device"],

  mixins: [access]
};
</script>

<style scoped>
.button {
  width: 150px;
}
</style>
